import { memo } from "react";

import { Box, Typography } from "@mui/material";

import KsbAppBar from "../../../../2_ksbHub/components/KsbAppBar";
import KsbAppToolbarContainer from "../../../../2_ksbHub/components/KsbAppToolbarContainer";
import KsbToolbarUser from "../../../../2_ksbHub/components/KsbToolbarUser";
import KsbSelector from "../../../../2_ksbHub/components/KsbSelector";

import { useAppContext } from "../../../../2_ksbHub/context/appContext";

import AskomaPeriodNavigator from "./AskomaPeriodNavigator";
import AskomaZoomNavigator from "./AskomaZoomNavigator";

function AskomaHeader({
  viewMode,
  setViewMode,
  viewOffset,
  setViewOffset,
  zoomLevel,
  setZoomLevel,
}) {
  const { isMobile } = useAppContext();

  const viewOptions = [
    { id: "today", label: "Heute" },
    { id: "week", label: "Woche" },
    { id: "month", label: "Monat" },
    { id: "year", label: "Jahr" },
    { id: "all", label: "Alle" },
  ];

  return (
    <KsbAppBar>
      <KsbAppToolbarContainer>
        <KsbToolbarUser
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: isMobile ? "stretch" : "center",
            gap: isMobile ? 1 : 0,
          }}
        >
          <Box sx={{ ml: 1 }}>
            <Typography variant="h6">Messdaten</Typography>
          </Box>

          <Box sx={{ width: isMobile ? "100%" : "auto" }}>
            <KsbSelector
              value={viewMode}
              options={viewOptions}
              getValue={(v) => v.id}
              getLabel={(v) => v.label}
              onChange={setViewMode}
            />
          </Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: isMobile ? "stretch" : "center",
              gap: 1,
            }}
          >
            <Box sx={{ width: isMobile ? "50%" : "auto" }}>
              <AskomaPeriodNavigator
                viewMode={viewMode}
                viewOffset={viewOffset}
                setViewOffset={setViewOffset}
              />
            </Box>

            <Box sx={{ width: isMobile ? "50%" : "auto" }}>
              <AskomaZoomNavigator
                zoomLevel={zoomLevel}
                setZoomLevel={setZoomLevel}
              />
            </Box>
          </Box>
        </KsbToolbarUser>
      </KsbAppToolbarContainer>
    </KsbAppBar>
  );
}

export default memo(AskomaHeader);
